// extracted by mini-css-extract-plugin
export default {"container":"FaqNav_container__d-Xu7","link":"FaqNav_link__eHM43","selected":"FaqNav_selected__1Neni","insta":"FaqNav_insta__8hIUl"};